var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.lang),expression:"lang"}],staticClass:"wrap"},[_c('Header',{ref:"sonh"}),(_vm.platform.isPC)?_c('EBike'):_c('EBikeM'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }